export default {
    getIframe: function () {
        return "<iframe src='" + window.location.href + "'></iframe>";
    },

    isInIframe: function () {
        return window.self !== window.top;
    },
};
